/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const favoriteToggleNodes = Array.from(document.querySelectorAll('.favorite-toggle'));
if (favoriteToggleNodes.length) {
    import(/* webpackChunkName: "FavoriteToggle" */ './components/FavoriteToggle').then(({ default: FavoriteToggle }) => {
        favoriteToggleNodes.forEach((node) => render(<FavoriteToggle {...parseDataToProps(node.dataset)} />, node));
    });
}

const favoritePopupNodes = Array.from(document.querySelectorAll('.favorite-popup'));
if (favoritePopupNodes.length) {
    import(/* webpackChunkName: "FavoritePopup" */ './components/FavoritePopup').then(({ default: FavoritePopup }) => {
        favoritePopupNodes.forEach((node) => render(<FavoritePopup {...parseDataToProps(node.dataset)} />, node));
    });
}

const favoritesCompareNodes = Array.from(document.querySelectorAll('.favorites-compare'));
if (favoritesCompareNodes.length) {
    import(/* webpackChunkName: "FavoritesCompare" */ './components/FavoritesCompare').then(({ default: FavoritesCompare }) => {
        favoritesCompareNodes.forEach((node) => render(<FavoritesCompare {...parseDataToProps(node.dataset)} />, node));
    });
}

